import { ComponentType, PropsWithChildren } from 'react';

import dayjs from 'dayjs';
import { t } from 'i18next';

import { IStages } from 'components/BusinessToolForm/Sections/ImplementationPlan/utils/form';
import { IStyleVariants } from 'components/OnePageTemplates/interfaces/variants';

import { ObjectValues } from 'helpers/types';

export interface IWrapperComponent {
  MobileCardWrapper: ComponentType<PropsWithChildren>;
}

export interface IChartStages extends Omit<IStages, 'to' | 'from' | 'status'> {
  status: string;
  to: dayjs.Dayjs;
  from: dayjs.Dayjs;
  duration: number;
  differenceWithStartDate: number;
}

export interface IGanttChartProps extends IWrapperComponent {
  data: IStages[];
  variant?: IStyleVariants;
}

export const GANTT_CHART_STATUSES = {
  DONE: 'Done',
  IN_PROGRESS: 'In progress',
  TO_DO: 'To do',
} as const;

export type IGanttChartStatuses = ObjectValues<typeof GANTT_CHART_STATUSES>;
